<template>
  <el-dropdown
    ref="dropdownRef"
    trigger="click"
    popper-class="user-dropdown-popper"
    style="margin-top: -3px !important; cursor: pointer"
  >
    <div data-v-2b3b0c9a="" class="dropdown-trigger">
      <el-avatar
        v-if="displayUserAvatar"
        style="width: 35px !important; height: 35px !important"
        :src="displayUserAvatar"
      />
      <el-avatar v-else class="header_avatar">
        <img :src="defaultAvatar" />
      </el-avatar>
    </div>
    <template #dropdown>
      <div class="tops">
        <div>
          <el-avatar v-if="displayUserAvatar" :src="displayUserAvatar" :size="50" />
          <el-avatar v-else :size="50">
            <img :src="defaultAvatar" />
          </el-avatar>
        </div>
        <div class="username">{{ displayUserName }}</div>
        <div v-if="userInfo.guid" class="ids">ID:{{ userInfo.guid }}</div>
        <div>
          <el-button @click="$emit('go-to-user-center')" type="primary" size="small" round plain>
            {{ $t('common.person.manageMyAccount') }}
          </el-button>
        </div>
      </div>
      <el-dropdown-menu>
        <el-dropdown-item
          v-if="showResourceQuotaEntries && (isEnterpriseMainUser || isNormalUser)"
          @click="$emit('go-to-station')"
        >
          <div class="items">
            <div class="left_text">
              <span><img src="@/assets/q1.png" /></span><span class="texts">{{ $t('common.seat') }}</span>
            </div>
            <div class="right_text">
              <span>
                {{ mailWorkPosition?.freePosition }}/<span style="color: var(--el-color-danger)">
                  {{ mailWorkPosition?.totalPosition }} {{ $t('common_ph22') }}
                </span>
              </span>
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item v-if="showResourceQuotaEntries" @click="$emit('go-to-store-details')">
          <div class="items">
            <div class="left_text">
              <span><img src="@/assets/q2.png" /></span><span class="texts">{{ $t('common.space') }}</span>
            </div>
            <div class="right_text">
              <span>
                {{ spaceSizeFormat(spaceSize?.freeLocation || 0, false) }}/<span style="color: var(--el-color-danger)">
                  {{ spaceSizeFormat(spaceSize?.effectiveLocation || 0) }}
                </span>
              </span>
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item v-if="showResourceQuotaEntries" @click="$emit('go-to-store-edm')">
          <div class="items">
            <div class="left_text">
              <span><img src="@/assets/edm.png" style="width: 16px; height: 16px" /></span>
              <span class="texts">{{ $t('userinfo.vip.edm') }}</span>
            </div>
            <div class="right_text">
              <span>
                {{ userDataInformation?.freeEdmNum ? userDataInformation?.freeEdmNum : 0 }}/<span style="color: var(--el-color-danger)">
                  {{ $t('userinfo.edm.number', { number: userDataInformation?.edmTotalNum ? userDataInformation?.edmTotalNum : 0 }) }}
                </span>
              </span>
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item v-if="showResourceQuotaEntries" @click="$emit('go-to-store-ai')">
          <div class="items">
            <div class="left_text">
              <span><img src="@/assets/AI.png" style="width: 16px; height: 16px" /></span>
              <span class="texts">{{ $t('userinfo.vip.AI') }}</span>
            </div>
            <div class="right_text">
              <span>
                {{ userDataInformation?.freeAiNum ? userDataInformation?.freeAiNum : 0 }}/<span style="color: var(--el-color-danger)">
                  {{ $t('userinfo.AI.number', { number: userDataInformation?.totalAiNum ? userDataInformation?.totalAiNum : 0 }) }}
                </span>
              </span>
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item v-if="isNormalUser || isEnterpriseMainUser" @click="$emit('handle-click-join-vip')">
          <div
            class="items"
            style="display: flex; flex-direction: column; align-items: flex-start; justify-content: center; height: max-content !important"
          >
            <div class="item_title">{{ $t('header.down.user') }}</div>
            <div class="inner_box_vip">
              <template v-if="isVipUser">
                <span>
                  <span>{{ $t('join.have') }}</span>
                  <img style="vertical-align: middle" class="plus-icon" :src="badgeIcon" alt="" />
                  <span>{{ $t('common.vip.member') }}</span>
                </span>
                <span>，{{ $t('join.vip.des') }}</span>
              </template>
              <template v-else>
                <span>
                  <span>{{ $t('join.vip') }}</span>
                  <img style="vertical-align: middle" class="plus-icon" :src="badgeIcon" alt="" />
                  <span>{{ $t('common.vip.member') }}</span>
                </span>
                <span>，{{ $t('join.vip.des') }}</span>
              </template>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item @click="$emit('go-to-setting')">
          <div class="items">
            <div class="left_text">
              <span class="sp_out"><img height="18" src="@/assets/usercenter/setting.svg" /></span>
              <span class="texts">{{ $t('common.setting.Safety') }}</span>
            </div>
            <div class="right_text">
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item @click="$emit('go-to-repair-order')">
          <div class="items">
            <div class="left_text">
              <span class="sp_out"><img height="18" src="@/assets/usercenter/message.svg" /></span>
              <span class="texts">{{ $t('common.cds42') }}</span>
            </div>
            <div class="right_text">
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item>
          <el-dropdown
            ref="switchAccountDropdownRef"
            trigger="hover"
            placement="left"
            :hide-on-click="false"
            popper-class="switch-account-popper"
          >
            <div class="items" @click.stop>
              <div class="left_text">
                <span class="sp_out" style="display: flex; justify-content: center; align-items: center">
                  <svg
                    t="1777361542068"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5378"
                    width="18"
                    height="18"
                  ><path d="M474.88 954.88c-29.44-38.4-35.2-90.88-13.44-134.4 3.2-7.04 8.32-12.8 12.8-19.2-16-21.12-26.24-48-26.24-76.8 0-70.4 57.6-128 128-128h180.48c-56.96-58.88-129.28-102.4-211.84-120.96A239.808 239.808 0 0 0 448 16C315.52 16 208 123.52 208 256c0 97.92 58.88 181.76 143.36 219.52C159.36 519.04 16 691.2 16 896c0 21.76 1.92 42.88 5.12 64 0 2.56 0 5.12 0.64 7.68 0 1.92 1.28 3.2 1.92 5.12 0.64 3.2 1.92 6.4 3.2 8.96 1.28 3.2 3.2 5.76 5.12 8.32 1.92 1.92 3.2 3.84 5.12 5.76 2.56 2.56 5.76 4.48 8.96 6.4a19.2 19.2 0 0 0 6.4 2.56c3.84 1.28 7.04 1.92 10.88 2.56 1.92 0 3.2 0.64 4.48 0.64h446.08l-40.96-53.12z" p-id="5379" fill="#000000"></path><path d="M960 772.48H576c-26.24 0-48-21.76-48-48s21.76-48 48-48h295.04l-15.36-23.04a48.192 48.192 0 0 1 13.44-66.56c22.4-14.72 51.84-8.32 66.56 13.44l64 97.28c9.6 14.72 10.24 33.92 1.92 49.28s-24.32 24.96-42.24 24.96zM640 1008c-14.72 0-28.8-6.4-38.4-18.56l-64-83.2a49.664 49.664 0 0 1-5.12-50.56c8.32-16.64 24.96-26.88 42.88-26.88h384c26.24 0 48 21.76 48 48s-21.76 48-48 48h-286.72l4.48 5.76c16 21.12 12.16 51.2-8.96 67.2-8.96 6.4-19.2 10.24-29.44 10.24z" p-id="5380" fill="#000000"></path></svg>
                </span>
                <span class="texts">{{ $t('common.header.switch.account') }}</span>
              </div>
              <div class="right_text">
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </div>
            <template #dropdown>
              <div class="switch-account-dropdown">
                <div
                  v-for="acc in accountList"
                  :key="acc.id"
                  class="switch-account-dropdown-item"
                  @click.stop="$emit('handle-switch-account', acc)"
                >
                  <div class="switch-account-dropdown-left">
                    <el-avatar v-if="acc.avatar" :src="acc.avatar" :size="28" />
                    <el-avatar v-else :size="28">
                      <img :src="defaultAvatar" />
                    </el-avatar>
                    <div class="switch-account-dropdown-text">
                      <div class="switch-account-dropdown-name">
                        <span class="switch-account-dropdown-name-text">{{ acc.userName }}</span>
                        <span
                          v-if="getAccountTypeTagText(acc)"
                          class="switch-account-dropdown-tag"
                          :class="getAccountTypeTagClass(acc)"
                        >{{ getAccountTypeTagText(acc) }}</span>
                      </div>
                      <div class="switch-account-dropdown-sub">{{ acc.account || acc.phone || '' }}</div>
                    </div>
                  </div>
                  <div v-if="String(acc.id) === String(activeAccountId)" class="switch-account-dropdown-right">
                    <el-icon>
                      <Select />
                    </el-icon>
                  </div>
                </div>
                <div class="switch-account-dropdown-footer" @click.stop="$emit('handle-login-more')">
                  <svg
                    style="margin-right: 10px"
                    t="1777362934177"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6632"
                    id="mx_n_1777362934178"
                    width="16"
                    height="16"
                  ><path d="M950.761 852.409642H607.434249a43.810304 43.810304 0 0 1 0-87.620609H950.761a43.810304 43.810304 0 0 1 0 87.620609z" fill="#6ea8f9" p-id="6633"></path><path d="M779.170642 1024a43.810304 43.810304 0 0 1-43.810305-43.810304v-343.180717a43.810304 43.810304 0 0 1 87.620609 0v343.180717a43.810304 43.810304 0 0 1-43.810304 43.810304zM423.577006 512.587715a256.29028 256.29028 0 1 1 255.852176-256.29028A256.436314 256.436314 0 0 1 423.577006 512.587715zM423.577006 87.773799a168.669671 168.669671 0 1 0 168.231568 168.523636A168.815706 168.815706 0 0 0 423.577006 87.773799z" fill="#6ea8f9" p-id="6634"></path><path d="M73.094572 862.632046a43.810304 43.810304 0 0 1-43.810304-43.810304 394.292738 394.292738 0 0 1 394.292738-394.292738 389.911708 389.911708 0 0 1 239.058226 80.756994 43.810304 43.810304 0 0 1-53.156502 69.658384A306.67213 306.67213 0 0 0 116.904876 818.821742a43.810304 43.810304 0 0 1-43.810304 43.810304z" fill="#6ea8f9" p-id="6635"></path></svg>
                  {{ $t('common.header.login.more.account') }}
                </div>
              </div>
            </template>
          </el-dropdown>
        </el-dropdown-item>

        <el-dropdown-item v-if="accountList.length <= 1" @click="$emit('handle-logout-current')">
          <div class="items">
            <div class="left_text">
              <span class="sp_out"><img height="18" src="@/assets/usercenter/signout.svg" /></span>
              <span class="texts">{{ $t('common.exit') }}</span>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item v-else>
          <el-dropdown
            ref="logoutDropdownRef"
            trigger="hover"
            placement="left"
            :hide-on-click="false"
            popper-class="logout-popper"
          >
            <div class="items" @click.stop>
              <div class="left_text">
                <span class="sp_out"><img height="18" src="@/assets/usercenter/signout.svg" /></span>
                <span class="texts">{{ $t('common.exit') }}</span>
              </div>
              <div class="right_text">
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </div>
            <template #dropdown>
              <div class="logout-dropdown">
                <div class="logout-dropdown-item" @click.stop="$emit('handle-logout-current')">
                  {{ $t('common.header.logout.current', { name: displayUserName }) }}
                </div>
                <div class="logout-dropdown-item" @click.stop="$emit('handle-logout-all')">
                  {{ $t('common.header.logout.all') }}
                </div>
              </div>
            </template>
          </el-dropdown>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
import { ref } from 'vue'
import { ArrowRightBold, Select } from '@element-plus/icons-vue'
import defaultAvatar from '@/assets/default/avatar.png'

export default {
  name: 'HeaderUserDropdown',
  components: {
    ArrowRightBold,
    Select,
  },
  props: {
    displayUserAvatar: {
      type: String,
      default: '',
    },
    displayUserName: {
      type: String,
      default: '',
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    showResourceQuotaEntries: {
      type: Boolean,
      default: false,
    },
    isEnterpriseMainUser: {
      type: Boolean,
      default: false,
    },
    isNormalUser: {
      type: Boolean,
      default: false,
    },
    mailWorkPosition: {
      type: Object,
      default: () => ({}),
    },
    spaceSizeFormat: {
      type: Function,
      default: () => '',
    },
    spaceSize: {
      type: Object,
      default: () => ({}),
    },
    userDataInformation: {
      type: Object,
      default: () => ({}),
    },
    isVipUser: {
      type: Boolean,
      default: false,
    },
    badgeIcon: {
      type: String,
      default: '',
    },
    accountList: {
      type: Array,
      default: () => [],
    },
    activeAccountId: {
      type: [String, Number],
      default: '',
    },
    getAccountTypeTagText: {
      type: Function,
      default: () => '',
    },
    getAccountTypeTagClass: {
      type: Function,
      default: () => '',
    },
  },
  emits: [
    'go-to-user-center',
    'go-to-station',
    'go-to-store-details',
    'go-to-store-edm',
    'go-to-store-ai',
    'handle-click-join-vip',
    'go-to-setting',
    'go-to-repair-order',
    'handle-switch-account',
    'handle-login-more',
    'handle-logout-current',
    'handle-logout-all',
  ],
  setup() {
    const dropdownRef = ref(null)
    const switchAccountDropdownRef = ref(null)
    const logoutDropdownRef = ref(null)

    const handleClose = () => {
      dropdownRef.value?.handleClose?.()
    }

    const closeSwitchAccountDropdown = () => {
      switchAccountDropdownRef.value?.handleClose?.()
    }

    const closeLogoutDropdown = () => {
      logoutDropdownRef.value?.handleClose?.()
    }

    return {
      defaultAvatar,
      dropdownRef,
      switchAccountDropdownRef,
      logoutDropdownRef,
      handleClose,
      closeSwitchAccountDropdown,
      closeLogoutDropdown,
    }
  },
}
</script>

<style scoped>
.dropdown-trigger {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tops {
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;
  margin-bottom: 10px;
}

.tops > .username {
  font-weight: 600;
  margin: 4px 0px;
}

.tops > .ids {
  color: #a699a6;
  font-weight: 400;
  margin: 4px 0px;
}

.items {
  width: 100%;
  min-width: 260px;
  display: flex;
  height: 48px;
  padding: 5px 12px;
  justify-content: space-between;
  border-top: 1px solid #e0e0e0;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.left_text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.left_text span {
  display: inherit;
  margin-right: 8px;
}

.left_text span img {
  text-align: center;
}

.right_text {
  display: flex;
  align-items: center;
}

.texts {
  font-size: 14px;
  font-weight: 500;
  color: #000000 !important;
}

.sp_out {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #eef1f3;
  position: relative;
}

.sp_out > img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.item_title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: black;
}

.inner_box_vip {
  margin-top: 10px;
  padding: 6px;
  margin-bottom: 10px;
  height: max-content;
  width: 100%;
  background: #f4f5f7;
}

.inner_box_vip > span {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
}

.plus-icon {
  width: 53px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 5px;
}

:deep(.el-avatar) {
  cursor: pointer;
  background: #f3f3f3 !important;
}

:deep(.el-dropdown-menu__item) {
  padding: 0px !important;
  transition: all 0.3s;
}

:deep(.el-dropdown-menu__item > .el-dropdown) {
  width: 100% !important;
}

:deep(.el-dropdown-menu__item > .el-dropdown > .el-dropdown__trigger) {
  width: 100% !important;
}

:deep(.el-dropdown-menu__item:not(.is-disabled):focus) {
  background: #f9f9f9;
  color: #121212;
  transition: all 0.3s;
}

:deep(.el-dropdown-menu__item:nth-of-type(4):not(.is-disabled):focus) {
  background: transparent !important;
}

:global(.switch-account-popper) {
  border-radius: 8px;
  overflow: hidden;
}

:global(.switch-account-popper .el-dropdown-menu) {
  padding: 0;
}

:global(.switch-account-popper .switch-account-dropdown) {
  min-width: 260px;
  background: #fff;
  padding: 8px 0;
}

:global(.switch-account-popper .switch-account-dropdown-item) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  cursor: pointer;
}

:global(.switch-account-popper .switch-account-dropdown-item:hover) {
  background: #f5f7fa;
}

:global(.switch-account-popper .switch-account-dropdown-left) {
  display: flex;
  align-items: center;
  gap: 10px;
}

:global(.switch-account-popper .switch-account-dropdown-text) {
  display: flex;
  flex-direction: column;
}

:global(.switch-account-popper .switch-account-dropdown-name) {
  font-size: 14px;
  color: #111;
  display: flex;
  align-items: center;
  gap: 6px;
}

:global(.switch-account-popper .switch-account-dropdown-name-text) {
  line-height: 1.2;
}

:global(.switch-account-popper .switch-account-dropdown-tag) {
  font-size: 12px;
  line-height: 16px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.65);
  background: rgba(0, 0, 0, 0.03);
  flex: 0 0 auto;
}

:global(.switch-account-popper .switch-account-dropdown-tag.is-personal) {
  border-color: rgba(47, 125, 255, 0.35);
  color: #2f7dff;
  background: rgba(47, 125, 255, 0.08);
}

:global(.switch-account-popper .switch-account-dropdown-tag.is-enterprise) {
  border-color: rgba(245, 108, 108, 0.35);
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.08);
}

:global(.switch-account-popper .switch-account-dropdown-sub) {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 2px;
}

:global(.switch-account-popper .switch-account-dropdown-right) {
  color: #2f7dff;
}

:global(.switch-account-popper .switch-account-dropdown-footer) {
  padding: 10px 12px;
  color: #2f7dff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

:global(.switch-account-popper .switch-account-dropdown-footer:hover) {
  background: #f5f7fa;
}

:global(.logout-popper) {
  border-radius: 8px;
  overflow: hidden;
}

:global(.logout-popper .el-dropdown-menu) {
  padding: 0;
}

:global(.logout-popper .logout-dropdown) {
  min-width: 220px;
  background: #fff;
  padding: 8px 0;
}

:global(.logout-popper .logout-dropdown-item) {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #111;
}

:global(.logout-popper .logout-dropdown-item:hover) {
  background: #f5f7fa;
}

:global(.user-dropdown-popper) {
  max-width: calc(100vw - 24px);
}

:global(.user-dropdown-popper .el-dropdown-menu) {
  width: 260px;
  max-width: calc(100vw - 24px);
  box-sizing: border-box;
}

:global(.user-dropdown-popper .inner_box_vip) {
  white-space: normal;
  word-break: break-word;
}
</style>
